import { injectable } from 'tsyringe'
import { GuideCategoryApiRepository } from '@/app/repositories/api/GuideCategoryRepository'
import { GuideCategory } from '@/domain/entities/GuideCategory'
import {
  PostGuideCategoryInterface,
  DeleteGuideCategoryInterface,
  UpdateGuideCategoryInterface,
} from '@/data/payload/contracts/GuideCategoryRequest'
@injectable()
export class GuideCategoryPresenter {
  private repository: GuideCategoryApiRepository

  constructor(repository: GuideCategoryApiRepository) {
    this.repository = repository
  }

  public loadGuideCategories(params: Object): Promise<GuideCategory> {
    return this.repository.getAll(params)
  }

  public postGuideCategories(
    payload: PostGuideCategoryInterface
  ): Promise<GuideCategory> {
    return this.repository.post(payload)
  }

  public updateGuideCategories(
    payload: UpdateGuideCategoryInterface,
    id: number
  ): Promise<GuideCategory> {
    return this.repository.update(payload, id)
  }

  public deleteGuideCategories(
    payload: DeleteGuideCategoryInterface
  ): Promise<GuideCategory> {
    return this.repository.delete(payload)
  }
}
